import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { DobFormComponent } from './components/dob-form/dob-form.component';

export default [registerFormInputComponent('customer-dob-form-input', DobFormComponent)];
